var React = require('react');

function Payments (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M19 4.58l-1.67 1.13-2.28-1.59a.66.66 0 00-.76 0L12 5.71 9.71 4.12a.66.66 0 00-.76 0L6.67 5.71 5.05 4.58a.67.67 0 00-1 .55v13.74a.67.67 0 001 .55l1.62-1.13L9 19.88a.66.66 0 00.76 0L12 18.29l2.29 1.59a.66.66 0 00.76 0l2.28-1.59L19 19.42a.67.67 0 001-.55V5.13a.67.67 0 00-1-.55zm-3.18 10.2H8.23v-1.85h7.54zm0-3.71H8.23V9.22h7.54z","fill":"#001b35","key":1})]);
}

Payments.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = Payments;

Payments.default = Payments;
